import './DamDetails.css'
import React, { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import Card from 'react-bootstrap/Card'
import doRequest from '../../requests/requests'
import Acl from './acl/Acl'
import Freq from './freq/Freq'
import Fem from './fem/Fem'
import Epicenter from './epicenter/Epicenter'
import Actions from '../../actions/Actions'
import { Button } from 'react-bootstrap'
import { useReducer } from 'react'
import { useEffect } from 'react'
import { useMemo } from 'react'

const VISUAL_TYPES = {
    FEM: "FEM",
    ACL: "ACL",
    FN: "FN",
    EP: "EP"
}
function Sidebar({ entityUrl, onClose, onActionSuccess }) {
    const [entity, setEntity] = useState()
    const [visual, setVisual] = useState()
    useEffect(_ => updateSideBar(), [entityUrl])
    //const [, forceUpdate] = useReducer(x => x + 1, 0);
    function updateSideBar() {
        getEntity(entityUrl).then(resp => setEntity(resp))
    }

    async function getEntity(url) {
        try {
            const res = await doRequest({ onProgress: undefined, uri: url, method: "GET" })
            if (res.status === 200) {
                return await res.json()
                //refresh() setDam should refresh component
            } else {
                if (res.status === 404) {
                    setEntity()
                } else alert('Get Entity error')
                console.error(await res.json())
            }

        } catch (error) {
            alert('Get Entity error')
            console.error(error)
        }
    }

    async function requestVisual(href, onSuccess, onError) {
        try {
            const request = await doRequest({ onProgress: undefined, uri: href, method: "GET" })
            if (request.ok) {
                onSuccess && onSuccess(await request.json())
            } else (onError && onError(request.body)) ?? alert(`Error DamSidebar JSX 55`)

        } catch (error) {
            (onError && onError(error)) ?? alert(`Error DamSidebar JSX 58`)
        }

    }
    const selectFem = (href) => {
        requestVisual(href, (data) => setVisual({ target: data, type: VISUAL_TYPES.FEM }))
    }
    const selectAcl = (href) => {
        requestVisual(href, (data) => setVisual({ target: data, type: VISUAL_TYPES.ACL }))
    }
    const selectFreq = (href) => {
        requestVisual(href, (data) => setVisual({ target: data, type: VISUAL_TYPES.FN }))
    }

    return entity !== undefined && (
        <>
            <Offcanvas show={entity !== undefined} onHide={onClose} placement='end' backdrop={false}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{entity.properties.name}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body >
                    <MainImage dam={entity} />
                    <DamProperties dam={entity} />
                    {/* <ImageList dam={entity} /> */}
                    <FileList title={'Accelerograms:'}
                        entityClass={'acls'}
                        onSelect={link => selectAcl(link)} />
                    <FileList title={'Finite Element Models:'}
                        entityClass={'fems'}
                        onSelect={link => selectFem(link)} />
                    <FileList title={'Measured Natural Frequencies:'}
                        entityClass={'freqs'}
                        onSelect={link => selectFreq(link)} />
                    <FileList title={'Supervisors:'}
                        entityClass={'users'}
                        onSelect={link => link}
                    />
                    <div className='dam_actions'>
                        <p></p>
                        {entity.actions !== undefined &&
                            <Actions actions={entity.actions}
                                onSuccess={() => { updateSideBar(); onActionSuccess?.() }}
                                onClose={() => { updateSideBar(); onActionSuccess?.() }} />}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {visual &&
                <Visual data={visual} unset={setVisual} entity={entity}>
                    <Actions actions={visual.target.actions}
                        onSuccess={() => {
                            alert(`Operation successful`)
                            setVisual()
                        }}
                        onClose={updateSideBar}
                        className='actions' />
                    <Button className='close-btn' variant="primary" onClick={() => setVisual()}>
                        Close
                    </Button>
                </Visual>
            }
        </>
    )

    function DamProperties() {
        return Object.keys(entity.properties).map((key) =>
            <div key={key}>
                {key.toUpperCase() === "INFO" && <br />}
                {key.toLocaleUpperCase() === "TITLE" && entity.properties[key]}
                {key.toUpperCase()}: {(() => {
                    switch (key.toUpperCase()) {
                        case "HEIGHT": return entity.properties[key] + ' m';
                        case "LOCATION": return entity.properties[key][0] + ' ºN, ' + entity.properties[key][1] + ' ºE';
                        case "NAME": return entity.properties[key] + ' Dam';
                        case "LATITUDE": return entity.properties[key] + ' ºN';
                        case "LONGITUDE": return entity.properties[key] + ' ºE';
                        case "RADIUS": return entity.properties[key] + ' m';
                        case "DATE":
                            var date = new Date(entity.properties[key]);
                            var formattedDate = date.toLocaleString('pt-PT', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                timeZone: 'UTC'
                            });
                            return formattedDate;
                        case "INFO":
                            return <>
                                <br />
                                <Epicenter epicenter={entity} epicenterData={entity.properties} />
                            </>
                        default: return entity.properties[key];
                    }
                })()}
            </div>)
    }

    function MainImage() {
        const mainImg = entity?.links?.find(
            (link) => link?.class.includes('main_image'))

        return mainImg && (
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={mainImg.href} />
            </Card>
        )
    }

    function LoadingButton({ onClick, isLoading, title }) {
        return (
            <Button
                variant="primary"
                disabled={isLoading}
                onClick={!isLoading ? onClick : null}
            >
                {isLoading ? 'Loading…' : title}
            </Button>
        );
    }


    function FileList({ entityClass, title, onSelect }) {
        const [loadingFile, setLoadingFile] = useState(null);
        const listLinks = entity?.entities?.find(
            (entity) => entity?.class?.includes(entityClass))?.links
        //console.log(listLinks)

        return listLinks !== undefined && (
            <div className='files'>
                <p>{title}</p>
                {
                    listLinks?.map((link) =>
                        <div key={link.href} className='file_button_container'>
                            {link.class[0] === 'user' ? (
                                <Button
                                    variant="outline-primary"
                                    key={link.href}
                                    onClick={() => onSelect(link.href)}
                                    className='file_button'
                                    disabled={true}
                                >
                                    {link.title}
                                </Button>
                            ) : (
                                <LoadingButton
                                    onClick={() => {
                                        setLoadingFile(link.href);
                                        onSelect(link.href);
                                    }}
                                    isLoading={loadingFile === link.href}
                                    title={link.title.length > 30
                                        ? link.title.slice(0, 30) + '...'
                                        : link.title
                                    }
                                    className='file-button'
                                />

                            )}
                        </div>
                    )
                }
            </div>)
    }
}

function Visual({ children, data, unset, entity }) {
    if (!data.target) return
    switch (data.type) {
        case VISUAL_TYPES.ACL:
            return <Acl acl={data.target} unsetAcl={unset} images={getImages(entity)}>
                {children}
            </Acl>
        case VISUAL_TYPES.FEM:
            return <Fem fem={data.target} unsetFem={unset}>
                {children}
            </Fem>
        case VISUAL_TYPES.FN:
            return <Freq freq={data.target} unsetFreq={unset}>
                {children}
            </Freq>
        default:
            break;
    }
}




function ImageList({ dam }) {
    const images = dam?.entities?.find(
        (entity) => entity?.class.includes('images'))

    return images && <div className='imgs'>
        {
            images?.links?.map((img) => {
                return (
                    <img src={img.href} className='img' alt=''></img>
                )
            })
        }
    </div>
}

function getImages(entity) {
    const imagesEntity = entity?.entities?.find(
        (entity) => entity?.class?.includes('images')
    );
    return imagesEntity?.links || [];
}

export default Sidebar
